import { useSyncExternalStore } from 'react';

/**
 * Secrets issued during a wizard (decision 3): they go straight into the generated files, but only live in this page's
 * memory — never in storage, never sent back to the hub. A reload loses them; the files then show {@link PLACEHOLDER}
 * and the step offers to issue a new one.
 */
const secrets = new Map<string, string>();
const listeners = new Set<() => void>();
let version = 0;

export const PLACEHOLDER = '<paste secret>';

export function rememberSecret(key: string, value: string): void {
  secrets.set(key, value);
  version++;
  listeners.forEach((l) => l());
}

export const secretOf = (key: string): string | undefined => secrets.get(key);

/** Test hook. */
export const forgetSecrets = () => {
  secrets.clear();
  version++;
};

/** Re-render when a secret is remembered; returns the lookup. */
export function useSecrets(): (key: string) => string | undefined {
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => version
  );
  return secretOf;
}
